import { createRouter, createWebHistory } from 'vue-router'
import LoginView from './views/LoginView.vue'
import MeasurementListView from './views/MeasurementListView.vue'
import { auth, loadCurrentUser } from './api'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    { path: '/', name: 'measurements', component: MeasurementListView },
    { path: '/:catchAll(.*)', redirect: '/' },
  ],
})

// One-shot session probe before the first navigation, so guards have an
// authoritative answer instead of falling back to "redirect to login then
// recover from the 401."
router.beforeEach(async (to) => {
  if (!auth.checked) {
    await loadCurrentUser()
  }
  if (!to.meta.public && !auth.user) {
    return { name: 'login', query: { next: to.fullPath } }
  }
  if (to.name === 'login' && auth.user) {
    return { name: 'measurements' }
  }
})

export default router
